import { Card, Divider, Statistic } from 'antd'

import LinkAddress from 'component/link/link-address'
import { useMarketPlaceDetailContext } from 'context/marketplace/market-place-detail-provider'
import ButtonEnableMarketPlace from 'pages/marketplace/component/button-enable-market-place'
import { ROUTES } from 'routes'
import { formatNumber } from 'utils/formatted-number'

const Information = () => {
  const { id, marketPlaceDetail, getMarketPlaceDetail } = useMarketPlaceDetailContext()

  return marketPlaceDetail ? (
    <Card style={{ margin: '0 auto 20px' }}>
      <div className="wrap-columns">
        <div className="columns">
          <div className="colum w-4">
            <Statistic
              title="PTO Name"
              value={marketPlaceDetail.fullName}
              valueStyle={{ fontSize: 16, fontWeight: 500 }}
              className="mb-4"
            />
            <Statistic
              title="Token Supply"
              value={formatNumber(marketPlaceDetail.tokenSupply, 2)}
              valueStyle={{ fontSize: 16, fontWeight: 500 }}
            />
          </div>
          <div className="colum w-4">
            <Statistic
              title="Price per Token"
              className="mb-4"
              value={formatNumber(marketPlaceDetail.price, 2)}
              valueStyle={{ fontSize: 16, fontWeight: 500 }}
              prefix={'$'}
              suffix={'USDC'}
            />
            <Statistic
              title="Total Holders"
              value={formatNumber(marketPlaceDetail.holders, 2)}
              valueStyle={{ fontSize: 16, fontWeight: 500 }}
            />
          </div>
          <div className="colum w-4">
            <Statistic
              title="Total Volume"
              className="mb-4"
              value={formatNumber(marketPlaceDetail.volume, 2)}
              valueStyle={{ fontSize: 16, fontWeight: 500 }}
              prefix={'$'}
            />
            <Statistic
              title="Status"
              className="mb-4"
              value={formatNumber(marketPlaceDetail.volume, 2)}
              valueStyle={{ fontSize: 16, fontWeight: 500 }}
              valueRender={() => {
                return (
                  <ButtonEnableMarketPlace
                    marketPlace={marketPlaceDetail}
                    onChange={getMarketPlaceDetail}
                  />
                )
              }}
            />
          </div>
        </div>
      </div>
      <Statistic
        title="Contract Address"
        value={marketPlaceDetail.contractAddress}
        valueStyle={{ fontSize: 16, fontWeight: 500 }}
        valueRender={() => {
          return <LinkAddress address={marketPlaceDetail.contractAddress} max={0} />
        }}
      />
      <Divider size="small" />
      <a href={`${ROUTES.PTO}/${id}`} target="_blank" rel="noreferrer" className="mt-3 block">
        View PTO detail
      </a>
    </Card>
  ) : null
}

export default Information
